module.exports = __webpack_public_path__ + "img/fdl_xia3.2dbd9275.png";